import { get } from './base';

const URL = '/site';

export const GetMain = () => get(`${URL}/main/`);
export const GetSiteFaqsAPI = () => get(`${URL}/faqs/`);
export const GetTermsAPI = terms_code => get(`${URL}/terms/${terms_code}/`);
export const GetTermsTypeListAPI = terms_code => get(`${URL}/terms/${terms_code}/list`);
export const GetTermsDetailAPI = int => get(`${URL}/terms/${int}/detail`);
export const GetRentPlaceAPI = () => get(`${URL}/rent-place/`);
export const GetCompanyHistoriesAPI = () => get(`${URL}/company-histories/`);
export const GetCompanyMediaNewsAPI = () => get(`${URL}/media-news/`);
export const GetCompanyFileAPI = () => get(`${URL}/company-introduction/`);
